module.exports = {
  domain: {
    Base_URL: process.env.NODE_ENV === 'production' ? 'https://cesa-dsc.com' : process.env.NODE_ENV === 'test' ? 'https://cesa-dsc.com' : 'https://cesa-dsc.com', // http://192.168.0.136:6888
    Base_M1_URL: process.env.NODE_ENV === 'production' ? 'https://cesa-dsc.com' : process.env.NODE_ENV === 'test' ? 'https://cesa-dsc.com' : 'https://cesa-dsc.com',
    Base_M2_URL: process.env.NODE_ENV === 'production' ? 'https://cesa-dsc.com' : process.env.NODE_ENV === 'test' ? 'https://cesa-dsc.com' : 'https://cesa-dsc.com',
    Preview_Domain: `https://showfile.cesa.cn/preview/onlinePreview`
  }
}
